import React from 'react';
import cn from 'classnames';
import RefundPaper from '../../../../Refund/Components/RefundPaper/RefundPaper';
import Details from './Details/Details';
import ShortDetails from './ShortDetails/ShortDetails';
import TotalRefund from './TotalRefund/TotalRefund';
import { useTheme } from '../../../../theme';
import ExtendedDetails from './ExtendedDetails/ExtendedDetails';
const PriceDetails = ({ className, prices, variant = 'details', ticketPrice }) => {
    const { PriceDetails: css } = useTheme('PriceDetails');
    return (React.createElement(RefundPaper, { className: cn(css.root, className) },
        variant === 'details' && React.createElement(Details, { prices: prices }),
        variant === 'short-details' && React.createElement(ShortDetails, { prices: prices, ticketPrice: ticketPrice }),
        variant === 'only-total' && React.createElement(TotalRefund, { price: prices.priceToPay }),
        variant === 'extended-details' && React.createElement(ExtendedDetails, { prices: prices })));
};
export default PriceDetails;
